import { Fulfillment } from "@secondcloset/types";
import { getAPIFromDomain } from "../../lib/api";

export type TransferStockPayload = {
  organization_id: string;
  product_id: string;
  facility: string;
  quantity: number;
  from_channel_name: string;
  to_channel_name: string;
};

export const transferStock = async (payload: TransferStockPayload): Promise<Fulfillment.Inventory> => {
  const api = getAPIFromDomain("fulfillment");
  const res = await api.put(`inventory_channels/transfer`, payload);
  return res.data;
};
